import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=d8a6efc0&"
import script from "./ExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ExchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports